import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-aspect-ratio.tsx
/**
* icon.24.aspect-ratio
*
* Keywords: fullscreen, expand, maximize, corner, resize, outward, enlarge, zoom
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy41IDdoOWEuNS41IDAgMCAxIC41LjV2OWEuNS41IDAgMCAxLS41LjVoLTlhLjUuNSAwIDAgMS0uNS0uNXYtOWEuNS41IDAgMCAxIC41LS41TTYgNy41QTEuNSAxLjUgMCAwIDEgNy41IDZoOUExLjUgMS41IDAgMCAxIDE4IDcuNXY5YTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtOUExLjUgMS41IDAgMCAxIDYgMTYuNXpNOS41IDlhLjUuNSAwIDAgMC0uNS41djJhLjUuNSAwIDAgMCAxIDBWMTBoMS41YS41LjUgMCAwIDAgMC0xem01LjUgMy41YS41LjUgMCAwIDAtMSAwVjE0aC0xLjVhLjUuNSAwIDAgMCAwIDFoMmEuNS41IDAgMCAwIC41LS41eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1472
*/
const Icon24AspectRatio = memo(function Icon24AspectRatio(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7.5 7h9a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5M6 7.5A1.5 1.5 0 0 1 7.5 6h9A1.5 1.5 0 0 1 18 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5zM9.5 9a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V10h1.5a.5.5 0 0 0 0-1zm5.5 3.5a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24AspectRatio };

//# sourceMappingURL=icon-24-aspect-ratio.js.map